module.exports = __webpack_public_path__ + "img/24_6.70e27eec.png";